import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useNav } from '../context/NavContext';
import '../styles/LeftNav.css';
import { FaBars, FaTimes } from 'react-icons/fa';

const LeftNav = () => {
  // State to control the collapsed state of the nav
  const [collapsed, setCollapsed] = useState(true);

  const { logout } = useAuth();
  const { setIsNavCollapsed } = useNav();
  const navigate = useNavigate();

  // When the user hovers over the nav, expand it; collapse when they leave.
  const handleMouseEnter = () => {
    if (window.innerWidth > 768) {
      setCollapsed(false);
      setIsNavCollapsed(false);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth > 768) {
      setCollapsed(true);
      setIsNavCollapsed(true);
    }
  };



  // Hover states for icons
  const [canvasHover, setCanvasHover] = useState(false);
  const [libraryHover, setLibraryHover] = useState(false);
  const [toneShiftHover, setToneShiftHover] = useState(false);
  const [chatHover, setChatHover] = useState(false);
  const [workflowsHover, setWorkflowsHover] = useState(false);
  const [prototyperHover, setPrototyperHover] = useState(false);
  const [settingsHover, setSettingsHover] = useState(false);
  const [logoutHover, setLogoutHover] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);

  // Handle logout
  const handleLogout = () => {
    logout();
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    navigate('/login');
  };



  return (
    <>




      <nav 
        className={`left-nav ${collapsed ? 'collapsed' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {/* Logo Section */}
        <div className="logo-section">
          <img className="logo" src="/images/logo48.png" alt="Logo" />
          {!collapsed && <span className="logo-title">Sighed Kick</span>}
        </div>

        {/* Main Navigation Items */}
        <ul className="nav-list">
          <li className="nav-item">
            <Link 
              to="/canvas" 
              onMouseEnter={() => setCanvasHover(true)}
              onMouseLeave={() => setCanvasHover(false)}
            >
              <img 
                className="nav-icon" 
                src={canvasHover ? "/images/canvas.gif" : "/images/canvas.png"} 
                alt="Canvas Icon" 
              />
              {!collapsed && <span>Canvas</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/prompt-manager" 
              onMouseEnter={() => setLibraryHover(true)}
              onMouseLeave={() => setLibraryHover(false)}
            >
              <img 
                className="nav-icon" 
                src={libraryHover ? "/images/library.gif" : "/images/library.png"} 
                alt="Library Icon" 
              />
              {!collapsed && <span>Library</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/tone-shift" 
              onMouseEnter={() => setToneShiftHover(true)}
              onMouseLeave={() => setToneShiftHover(false)}
            >
              <img 
                className="nav-icon" 
                src={toneShiftHover ? "/images/toneshift.gif" : "/images/toneshift.png"} 
                alt="Tone Shift Icon" 
              />
              {!collapsed && <span>ToneShift</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/chat" 
              onMouseEnter={() => setChatHover(true)}
              onMouseLeave={() => setChatHover(false)}
            >
              <img 
                className="nav-icon" 
                src={chatHover ? "/images/chat.gif" : "/images/chat.png"} 
                alt="Chat Icon" 
              />
              {!collapsed && <span>Chat</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/workflows" 
              onMouseEnter={() => setWorkflowsHover(true)}
              onMouseLeave={() => setWorkflowsHover(false)}
            >
              <img 
                className="nav-icon" 
                src={workflowsHover ? "/images/workflows.gif" : "/images/workflows.png"} 
                alt="Workflows Icon" 
              />
              {!collapsed && <span>Workflows</span>}
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              to="/prototyper" 
              onMouseEnter={() => setPrototyperHover(true)}
              onMouseLeave={() => setPrototyperHover(false)}
            >
              <img 
                className="nav-icon" 
                src={prototyperHover ? "/images/prototype.gif" : "/images/prototype.png"} 
                alt="Prototyper Icon" 
              />
              {!collapsed && <span>Prototyper</span>}
            </Link>
          </li>
        </ul>

        {/* Bottom Navigation for Settings and Logout */}
        <div className="bottom-nav">
          <div
            className="settings-section"
            onMouseEnter={() => setSettingsHover(true)}
            onMouseLeave={() => {
              setSettingsHover(false);
              setSettingsOpen(false);
            }}
            onClick={() => setSettingsOpen(!settingsOpen)}
          >
            <img
              src={settingsHover ? "/images/settings50.gif" : "/images/settings50.png"}
              alt="Settings"
              className="bottom-icon"
            />
            <span className="bottom-text">Settings</span>
            {settingsOpen && (
              <ul className="settings-dropdown">
                <li>
                  <Link to="/account">Account</Link>
                </li>
                <li>
                  <Link to="/auth-tokens">Auth Tokens</Link>
                </li>
              </ul>
            )}
          </div>
          <div
            className="logout-section"
            onMouseEnter={() => setLogoutHover(true)}
            onMouseLeave={() => setLogoutHover(false)}
            onClick={handleLogout}
          >
            <img
              src={logoutHover ? "/images/logout50.gif" : "/images/logout50.png"}
              alt="Logout"
              className="bottom-icon"
            />
            <span className="bottom-text">Logout</span>
          </div>
        </div>
      </nav>
    </>
  );
};

export default LeftNav;
